"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const parseSvgFile_1 = __importDefault(require("../parsers/parseSvgFile"));
const validateSvg = async (url) => {
    try {
        const request = await (0, axios_1.default)({
            method: 'GET',
            url,
            responseType: 'text',
        });
        if (!request.data)
            return false;
        const response = (0, parseSvgFile_1.default)(request.data);
        return !!response;
    }
    catch (_a) {
        return false;
    }
};
exports.default = validateSvg;
